<template>
    <div v-if="listRoute">
        <template v-if="!adverseEventId">
            <adverse-event-data-table :list-route="listRoute"></adverse-event-data-table>
        </template>
        <template v-if="adverseEventId">
            <adverse-event-form-component></adverse-event-form-component>
        </template>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            datatableKey: 0,
            listRoute: null,
        };
    },
    computed: {
        tab() {
            return this.$store.state.patients.tab;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        adverseEventId() {
            return this.$store.state.adverse_event.adverse_event.id;
        },
    },
    watch: {
        tab(val) {
            if (val === 6) {
                this.$store.dispatch('adverse_event/resetAdverseEvent');
            }
        },
    },

    mounted() {
        this.listRoute = route('api.v1.patients.adverse-events.index', {
            patient: this.patientId,
        });
        // this.listRoute = [
        //     route('api.v1.patients.adverse-events.index', {
        //         patient: this.patientId,
        //     }),
        //     route('api.v1.patients.adverse-events.show', {
        //         patient: this.patientId,
        //         adverse_event: this.patientId,
        //     }),
        //     route('api.v1.patients.adverse-events.store', {
        //         patient: this.patientId,
        //     }),
        //     route('api.v1.patients.adverse-events.update', {
        //         patient: this.patientId,
        //         adverse_event: this.patientId,
        //     }),
        // ];
    },
};
</script>
